import React, { useEffect, useState, useRef } from 'react';
import axios, { formToJSON } from 'axios';
import $, { data } from 'jquery';
import 'select2';
import '../css/Select2.css';
import '../css/Login.css';
import '../css/Materialize.css';
import '../css/Style.css';
import '../css/new.css';
import reloadToken from '../helper/reloadtoken';
import HeaderMenu from '../template/HeaderMenu';
import { apiConfig } from '../helper/apiConfig';
import 'react-toastify/dist/ReactToastify.css';
import {utils, writeFile} from 'xlsx';
import { Bar, Line } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement } from 'chart.js';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend,ChartDataLabels, PointElement, LineElement);

const mainhost = process.env.REACT_APP_API_HOST_MASTER;

const API_Datainout = mainhost + "DatainoutData"
const API_PT_DROPDOWN = mainhost + "KasForDropdown"


const API_OmsetAllReportHarian = mainhost + "OmsetAllReportHarian"
const API_OmsetReportHarian = mainhost + "OmsetReportHarian"
const API_OmsetKasaranOmset = mainhost + "OmsetKasaranOmset"
const API_OmsetMonthTrend = mainhost + "OmsetMonthTrend"
const API_OmsetMonthTrendRupiah = mainhost + "OmsetMonthTrendRupiah"
const API_OmsetSusunanAsset = mainhost + "OmsetSusunanAsset"


const ReportOmset = () => {
  const token = localStorage.getItem('token');

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const getYesterdayDate = () => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    const year = yesterday.getFullYear();
    const month = String(yesterday.getMonth() + 1).padStart(2, '0');
    const day = String(yesterday.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const [TokenNew, setToken] = useState(null);
  const [DataOmsetAllReportHarian, setOmsetAllReportHarian] = useState(null);
  const [DataOmsetReportHarian, setOmsetReportHarian] = useState(null);
  const [DataOmsetKasaranOmset, setOmsetKasaranOmset] = useState(null);
  const [DataOmsetMonthTrend, setOmsetMonthTrend] = useState(null);
  const [DataOmsetMonthTrendRupiah, setOmsetMonthTrendRupiah] = useState(null);
  const [SusunanAsset, setSusunanAsset] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [currentSelectedDate, setCurrentSelectedDate] = useState(getYesterdayDate());
  const tableSummary = useRef(null); const tableOmsetAll = useRef(null);  const tableOmsetHarian = useRef(null);  const tableKasaranOmset = useRef(null); 
  const config = apiConfig(token);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, index) => currentYear - index);
  const current_month = new Date().getMonth() + 1;

  const selectForBln = useRef(null);
  const selectForYearh = useRef(null);

  const year_local = localStorage.getItem("year_selected");
  const month_local = localStorage.getItem("month_selected");

  const year_selected = year_local ?  parseInt(year_local) : years[0]
  const month_selected = month_local ? parseInt(month_local) : current_month

  const [selectedYear, setSelectedYear] = useState(year_selected);
  const [selectedMonth, setSelectedMonth] = useState(month_selected);
  const [KasList, setKasList] = useState([]);
  
  const [chartData, setChartData] = useState({
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    datasets: [
      {
        label: 'Kasaran Omset',
        data: [12000, 15000, 18000, 20000, 22000, 25000, 27000, 30000, 32000, 35000, 37000, 40000],
        backgroundColor: [
          'rgba(255, 99, 132, 0.6)',  // January
          'rgba(54, 162, 235, 0.6)',  // February
          'rgba(255, 206, 86, 0.6)',  // March
          'rgba(75, 192, 192, 0.6)',  // April
          'rgba(153, 102, 255, 0.6)', // May
          'rgba(255, 159, 64, 0.6)',  // June
          'rgba(199, 199, 199, 0.6)', // July
          'rgba(83, 102, 255, 0.6)',  // August
          'rgba(255, 99, 71, 0.6)',   // September
          'rgba(60, 179, 113, 0.6)',  // October
          'rgba(123, 104, 238, 0.6)', // November
          'rgba(255, 215, 0, 0.6)',   // December
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
          'rgba(255, 159, 64, 1)',
          'rgba(199, 199, 199, 1)',
          'rgba(83, 102, 255, 1)',
          'rgba(255, 99, 71, 1)',
          'rgba(60, 179, 113, 1)',
          'rgba(123, 104, 238, 1)',
          'rgba(255, 215, 0, 1)',
        ],
        borderWidth: 1,
      },
    ],
  });

  const months = [
    { value: '1', label: 'Januari' },
    { value: '2', label: 'Februari' },
    { value: '3', label: 'Maret' },
    { value: '4', label: 'April' },
    { value: '5', label: 'Mei' },
    { value: '6', label: 'Juni' },
    { value: '7', label: 'Juli' },
    { value: '8', label: 'Agustus' },
    { value: '9', label: 'September' },
    { value: '10', label: 'Oktober' },
    { value: '11', label: 'November' },
    { value: '12', label: 'Desember' },
  ];
  

  const exportToExcel = (data_excel, filename) => {
    const workbook = utils.book_new();
  
    // Loop through each sheet data object
    data_excel.forEach((sheet) => {
      const worksheet = utils.json_to_sheet(sheet.data);
  
      // Add optional column headers if defined
      if (sheet.columns) {
        utils.sheet_add_aoa(worksheet, sheet.columns, { origin: 'A1' });
      }
  
      // Append the sheet to the workbook
      utils.book_append_sheet(workbook, worksheet, sheet.name);
    });
    writeFile(workbook, filename+'.xlsx');
  };

  const fetchDropdownOptions = async () => {
    try {
      const config = apiConfig(token);
      const response = await axios.post(`${API_PT_DROPDOWN}`, null, config);
      return response.data;
    } catch (error) {
      console.error('Error fetching column names:', error);
      return [];
    }
  };

  const getDatainoutData = async () => {
    try {

      const formData = new FormData();
        formData.append('bln',month_selected);
        formData.append('thn',year_selected);
        // formData.append('email', user);
        // formData.append('password', pass);
        const response = await axios.post(`${API_Datainout}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const getOmsetAllReportHarian = async (selectedDate) => {
    try {

      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      formData.append('tgl',selectedDate);
      const response = await axios.post(`${API_OmsetAllReportHarian}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const getOmsetReportHarian = async (selectedDate) => {
    try {

      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      formData.append('tgl',selectedDate);
      const response = await axios.post(`${API_OmsetReportHarian}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const getOmsetKasaranOmset = async (selectedDate) => {
    try {

      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      formData.append('tgl',selectedDate);
      const response = await axios.post(`${API_OmsetKasaranOmset}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const getOmsetMonthTrend = async (selectedDate) => {
    try {
      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      const response = await axios.post(`${API_OmsetMonthTrend}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const getOmsetMonthTrendRupiah = async (selectedDate) => {
    try {
      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      const response = await axios.post(`${API_OmsetMonthTrendRupiah}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const fetchSusunanAsset = async () => {
    try {
      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      const response = await axios.post(`${API_OmsetSusunanAsset}`, formData, config);
      const data = response.data;
      setSusunanAsset(data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const handleChange = () => {

  }

  const handleMonthChange = (event) => {
    const value = event.target.value;
    let intValue;
    if (value.trim() !== '') {
         intValue = parseInt(value, 10);
        if (!isNaN(intValue)) {
        } else {
          intValue="";
        }
    } else {
      intValue="";
    }
    setSelectedMonth(intValue);
    localStorage.setItem("month_selected", intValue);
    window.location.reload();
  }

  const handleSelectYearChange = (year) => {
    const value = year.target.value;
    let intValue = parseInt(value, 10);
    if (!isNaN(intValue)) {
      setSelectedYear(intValue); // Update selected year state
      localStorage.setItem("year_selected", intValue); // Store in local storage
    } else {
      setSelectedYear(""); // Reset selected year state
      localStorage.removeItem("year_selected"); // Remove from local storage
    }
    window.location.reload();
  }
  
  const prosesReportOmset = async (event) => {
    const value = event.target.value;
    const sum_OmsetAllReportHarian = await getOmsetAllReportHarian(value);
    setOmsetAllReportHarian(sum_OmsetAllReportHarian);
  }
  $(selectForBln.current).on('change', handleMonthChange);
  $(selectForYearh.current).on('change', handleSelectYearChange);

  useEffect(() => {
    setIsLoading(true);
    //TYPE
    $('.js-example-basic-single').select2();
    $('.js-example-basic-multiple').select2({
      theme: "classic"
    });
    
    const fetchData = async () => {
      await new Promise((resolve) => setTimeout(resolve, 100));
      const newToken = await reloadToken();
      setToken(newToken);
      // const asset_data = await getDatainoutData();
      // setDatainoutData(asset_data);
      // const report_toko = await getReportToko();
      // setDatainoutReportToko(report_toko);
      const sum_OmsetAllReportHarian = await getOmsetAllReportHarian(currentSelectedDate);
      setOmsetAllReportHarian(sum_OmsetAllReportHarian);
      const sum_OmsetReportHarian = await getOmsetReportHarian(currentSelectedDate);
      setOmsetReportHarian(sum_OmsetReportHarian);
      const sum_OmsetKasaranOmset = await getOmsetKasaranOmset(currentSelectedDate);
      setOmsetKasaranOmset(sum_OmsetKasaranOmset);
      const sum_OmsetMonthTrend = await getOmsetMonthTrend(currentSelectedDate);
      setOmsetMonthTrend(sum_OmsetMonthTrend);
      const sum_OmsetMonthTrendRupiah = await getOmsetMonthTrendRupiah(currentSelectedDate);
      setOmsetMonthTrendRupiah(sum_OmsetMonthTrendRupiah);
      const kas_list_data = await fetchDropdownOptions();
      for (let i = 0; i < kas_list_data.length; i++) {
        if (kas_list_data[i].value === "9") {
          kas_list_data.splice(i, 1);
          break;
        }
      }
      for (let i = 0; i < kas_list_data.length; i++) {
        if (kas_list_data[i].value === "10") {
          kas_list_data.splice(i, 1);
          break;
        }
      }
      setKasList(kas_list_data);
      setIsLoading(false);
    };

    new Promise((resolve) => setTimeout(resolve, 100));

    function isMobileDevice() {
      const mobileScreenWidth = 768;
      return window.innerWidth < mobileScreenWidth;
    }

    setTimeout(function () {
      var calcChainLength = 0;

    }, 1500);

    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      setToken(storedToken);
    } else {
      // If token is not found in localStorage, reload it
      reloadToken().then(newToken => {
        setToken(newToken);
        // Store the token in localStorage for future use
        localStorage.setItem('token', newToken);
      });
    }

    fetchData(); 
    fetchSusunanAsset(); 
    
    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log('Tab is hidden');
        // luckysheet.refresh();
      } else {
        console.log('Tab is visible');
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      // clearInterval(intervalId);

      $(selectForBln.current).on('change', handleMonthChange);
      $(selectForYearh.current).on('change', handleSelectYearChange);
    };
  }, []);

  const formatNumberWithoutDecimals = (num) => {
    // convert num into float
    num = parseFloat(num);
    if (isNaN(num)) {
      return '0';
    }
    return num.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  };
  const inputStyle120 = {
    // Define your custom CSS styles here
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '2px',
    fontSize: '16px',
    width: '120px',
    height: '30px',
    marginTop: '5px',
  };
  const selectStyle120 = {
    // Define your custom CSS styles here
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '2px',
    fontSize: '16px',
    width: '120px',
    height: '10%',
    marginTop: '5px',
  };
  const labelStyel = {
    marginTop: '22px',
  };
  const randomKey = () => {
    return Math.random().toString(36).substr(2, 9);
  }
  const omset1 = () => {

    // Proses tableOmset
    const dataTable_sum = tableOmsetAll.current;
    const data = [];

    // Extract headers from the table
    const headers = Array.from(dataTable_sum.querySelectorAll('thead th')).map((th) => th.textContent);

    // Extract data from the table body
    const tableBody = dataTable_sum.querySelector('tbody');
    const rows = Array.from(tableBody.querySelectorAll('tr'));
    const dataRows = rows.map((row) => Array.from(row.querySelectorAll('td')).map((td) => td.textContent));

    return [headers, dataRows];
  }
  const onDownloadAll  = () => {
    const data = [];

    // const sub_summary1 = sub_summary();
    // const headers_sub1 = sub_summary1[0];
    // const dataRows2_sub1 = sub_summary1[1];

    // // Combine headers and data into the desired format
    // data.push({
    //   name: 'Sub Summary',
    //   data: [...dataRows2_sub1],
    //   columns : [headers_sub1]
    // });

    // exportToExcel(data,'Excel All');
  }
  const remove_dot = (dataRow) => {
    for (let i = 0; i < dataRow.length; i++) {
      if (typeof dataRow[i] === "undefined") {
        continue;
      }
      for (let j = 0; j < dataRow[i].length; j++) {
        if (typeof dataRow[i][j] === "undefined") {
          continue;
        }
        // try convert to float
        dataRow[i][j] = dataRow[i][j].replace(/\./g, '');
        if (parseFloat(dataRow[i][j]) >= 0) {
          dataRow[i][j] = parseFloat(dataRow[i][j]);
        }
      }
    }
    return dataRow;
  }

  const onDownloadAllClean  = () => {
    const data = [];

    const omset = omset1();
    const headersOmset = omset[0];
    const dataRowsOmset = remove_dot(omset[1]);

    // Combine headers and data into the desired format
    data.push({
      name: 'Omset Harian',
      data: [...dataRowsOmset],
      columns : [headersOmset]
    });

    exportToExcel(data,'Excel All Numeric');
  }
  return (
    <div>
      <HeaderMenu title={"Report All Divisi"} subtitle={"Report All Divis"} />
      {/* <ToastContainer /> */}
      
      <div style={{ textAlign: 'center' }}>
        <table border={0}>
          <thead>
          </thead>
          <tbody>
            <tr>
              <td>
                <input type="date" name="date" id="date" style={inputStyle120} defaultValue={currentSelectedDate} onChange={prosesReportOmset} />
              </td>
              <td>
                <select style={selectStyle120} ref={selectForBln} className="js-example-basic-single style-select-report" value={selectedMonth || ""} onChange={handleChange}>
                <option value="">-PILIH-</option>
                  {months.map((month) => (
                    <option key={month.value} value={month.value}>
                      {month.label}
                    </option>
                  ))}
                </select>
              </td>
              <td>
              <select style={selectStyle120} ref={selectForYearh} className="js-example-basic-single style-select-report" value={selectedYear} onChange={handleChange}>
                  <option value="">-PILIH-</option>
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </td>  
              <td>
                <button onClick={onDownloadAllClean} className="btn btn-info"> Export Excel</button>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
      {/* <button onClick={onDownloadAll}> Export excel All </button> */}
      <div className="containers" style={{ width : "100%"}}>

        <ul className="tabs" style={{ width: "100%"}}>
          {/* <li className="tab-link" data-tab="tab-1">Summary</li> */}
          <li className="tab-link current" data-tab="omset">All Daily</li>
          <li className="tab-link" data-tab="dailyOmset">All Monthly</li>
          <li className="tab-link" data-tab="kasaranOmset">Kasaran</li>
          <li className="tab-link" data-tab="trendOmset">Trend</li>
        </ul>


        <div id="omset" className="tab-content current">
          <div style={{ textAlign: 'center', overflow:'auto', height:'80vh', width:'100%'}}>

          {/* <DownloadTableExcel filename="Datainout" sheet="dataInOut" currentTableRef={tableDataInOut.current} ><button> Export excel </button></DownloadTableExcel> */}
            <table ref={tableOmsetAll} className='table table-bordered' style={{ width:'1600px'}}>
              <thead>
                <tr>
                  <th>Asset</th>
                  <th>Daftar</th>
                  <th>New Depo</th>
                  <th style={{backgroundColor:'#873e23', color:'white'}} >% Depo</th>
                  <th>Form Depo</th>
                  <th>Form WD</th>
                  <th style={{backgroundColor:'#873e23', color:'white'}}>Total Form</th>
                  <th>DP Value</th>
                  <th>WD Value</th>
                  <th>Adjustment</th>
                  <th style={{backgroundColor:'#873e23', color:'white'}}>DP - WD - Adjustment</th>
                  <th style={{backgroundColor:'#f1ee8e'}}>Winlose Kotor</th>
                  <th>Bonus Harian</th>
                  <th>Winlose Bersih</th>
                  <th>Naik Tampung</th>
                  <th>Suntik Dana</th>
                </tr>
              </thead>
              <tbody>
              { isLoading ? <tr><td>Loading...</td></tr> :
              ( DataOmsetAllReportHarian && typeof DataOmsetAllReportHarian === 'object') ? (
              Object.keys(DataOmsetAllReportHarian).map((item,index) => (
                <tr key={'rall'+index}  style={DataOmsetAllReportHarian[item]["nama_toko"] === "Total" ? { backgroundColor: "yellow" } : null} className={DataOmsetAllReportHarian[item]["nama_toko"] === "Total" ? 'total_row' : null}>
                        {/* <td style={{ textAlign:'left'}}>{item}</td>  */}
                        <td style={{ textAlign:'left', width:'140px'}}>{DataOmsetAllReportHarian[item]["nama_toko"]}</td> 
                        <td style={{ textAlign:'center', width:'50px'}}>{formatNumberWithoutDecimals(DataOmsetAllReportHarian[item]["register"])}</td> 
                        <td style={{ textAlign:'center', width:'50px'}}>{formatNumberWithoutDecimals(DataOmsetAllReportHarian[item]["new_depo"])}</td> 
                        <td style={{ textAlign:'center', width:'50px'}}>{formatNumberWithoutDecimals(DataOmsetAllReportHarian[item]["persen_depo"])}</td> 
                        <td style={{ textAlign:'center', width:'50px'}}>{formatNumberWithoutDecimals(DataOmsetAllReportHarian[item]["form_depo"])}</td> 
                        <td style={{ textAlign:'center', width:'50px'}}>{formatNumberWithoutDecimals(DataOmsetAllReportHarian[item]["form_wd"])}</td> 
                        <td style={{ textAlign:'center', width:'60px'}}>{formatNumberWithoutDecimals(DataOmsetAllReportHarian[item]["total_form"])}</td> 
                        <td style={{ textAlign:'right', width:'70px'}}>{formatNumberWithoutDecimals(DataOmsetAllReportHarian[item]["dp_value"])}</td> 
                        <td style={{ textAlign:'right', width:'70px'}}>{formatNumberWithoutDecimals(DataOmsetAllReportHarian[item]["wd_value"])}</td> 
                        <td style={{ textAlign:'right', width:'70px', color:'red'}}>{formatNumberWithoutDecimals(DataOmsetAllReportHarian[item]["adjustment"])}</td> 
                        <td style={{ textAlign:'right', width:'70px'}} className={DataOmsetAllReportHarian[item]["dp_wd_adjust"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetAllReportHarian[item]["dp_wd_adjust"])}</td> 
                        <td style={{ textAlign:'right', width:'70px', backgroundColor:'#f1ee8e'}} className={DataOmsetAllReportHarian[item]["winlose_kotor"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetAllReportHarian[item]["winlose_kotor"])}</td> 
                        <td style={{ textAlign:'right', width:'70px'}} className={DataOmsetAllReportHarian[item]["bonus_harian"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetAllReportHarian[item]["bonus_harian"])}</td> 
                        <td style={{ textAlign:'right', width:'70px'}} className={DataOmsetAllReportHarian[item]["winlose_bersih"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetAllReportHarian[item]["winlose_bersih"])}</td> 
                        <td style={{ textAlign:'right', width:'70px'}} className={DataOmsetAllReportHarian[item]["naik_tampung"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetAllReportHarian[item]["naik_tampung"])}</td> 
                        <td style={{ textAlign:'right', width:'70px'}} className={DataOmsetAllReportHarian[item]["suntik_dana"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetAllReportHarian[item]["suntik_dana"])}</td> 
                    </tr>
                // ))
              ))
            ) : null
              }
            </tbody>
            </table>
          </div>
        </div>
        <div id="dailyOmset" className="tab-content ">
          <div style={{ textAlign: 'center', overflow:'auto', height:'80vh', width:'100%'}}>

          <table ref={tableOmsetHarian} >
            <tbody>
          { isLoading ? <tr><td>Loading...</td></tr> :
              ( DataOmsetReportHarian && typeof DataOmsetReportHarian === 'object') ? (
              Object.keys(DataOmsetReportHarian).map((item0,index) => (
                Object.keys(DataOmsetReportHarian[item0]).map((item,index0) => (
            <tr>
              <td>
                <table className='table table-bordered' style={{ width:'1600px', marginTop:"20px"}}>
                  <thead>
                    <tr><th colSpan="16">{item}</th></tr>
                    <tr>
                      <th>Asset</th>
                      <th>Daftar</th>
                      <th>New Depo</th>
                      <th style={{backgroundColor:'#873e23', color:'white'}} >% Depo</th>
                      <th>Form Depo</th>
                      <th>Form WD</th>
                      <th style={{backgroundColor:'#873e23', color:'white'}}>Total Form</th>
                      <th>DP Value</th>
                      <th>WD Value</th>
                      <th>Adjustment</th>
                      <th style={{backgroundColor:'#873e23', color:'white'}}>DP - WD - Adjustment</th>
                      <th style={{backgroundColor:'#f1ee8e'}}>Winlose Kotor</th>
                      <th>Bonus Harian</th>
                      <th>Winlose Bersih</th>
                      <th>Naik Tampung</th>
                      <th>Suntik Dana</th>
                    </tr>
                  </thead>
                  <tbody>
                    { Object.keys(DataOmsetReportHarian[item0][item]).map((item1,index2) => (
                    <tr key={'rharian'+item+item1+index}  style={DataOmsetReportHarian[item0][item][item1]["tanggal"] === "Total" ? { backgroundColor: "yellow" } : null} className={DataOmsetReportHarian[item0][item][item1]["tanggal"] === "Total" ? 'total_row': null}>
                            {/* <td style={{ textAlign:'left'}}>{item}</td>  */}
                            <td style={{ textAlign:'left', width:'140px'}}>{DataOmsetReportHarian[item0][item][item1]["tanggal"]}</td> 
                            <td style={{ textAlign:'center', width:'50px'}}>{formatNumberWithoutDecimals(DataOmsetReportHarian[item0][item][item1]["register"])}</td> 
                            <td style={{ textAlign:'center', width:'50px'}}>{formatNumberWithoutDecimals(DataOmsetReportHarian[item0][item][item1]["new_depo"])}</td> 
                            <td style={{ textAlign:'center', width:'50px'}}>{formatNumberWithoutDecimals(DataOmsetReportHarian[item0][item][item1]["persen_depo"])}</td> 
                            <td style={{ textAlign:'center', width:'50px'}}>{formatNumberWithoutDecimals(DataOmsetReportHarian[item0][item][item1]["form_depo"])}</td> 
                            <td style={{ textAlign:'center', width:'50px'}}>{formatNumberWithoutDecimals(DataOmsetReportHarian[item0][item][item1]["form_wd"])}</td> 
                            <td style={{ textAlign:'center', width:'60px'}}>{formatNumberWithoutDecimals(DataOmsetReportHarian[item0][item][item1]["total_form"])}</td> 
                            <td style={{ textAlign:'right', width:'70px'}}>{formatNumberWithoutDecimals(DataOmsetReportHarian[item0][item][item1]["dp_value"])}</td> 
                            <td style={{ textAlign:'right', width:'70px'}}>{formatNumberWithoutDecimals(DataOmsetReportHarian[item0][item][item1]["wd_value"])}</td> 
                            <td style={{ textAlign:'right', width:'70px', color:'red'}}>{formatNumberWithoutDecimals(DataOmsetReportHarian[item0][item][item1]["adjustment"])}</td> 
                            <td style={{ textAlign:'right', width:'70px'}} className={DataOmsetReportHarian[item0][item][item1]["dp_wd_adjust"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetReportHarian[item0][item][item1]["dp_wd_adjust"])}</td> 
                            <td style={{ textAlign:'right', width:'70px', backgroundColor:'#f1ee8e'}} className={DataOmsetReportHarian[item0][item][item1]["winlose_kotor"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetReportHarian[item0][item][item1]["winlose_kotor"])}</td> 
                            <td style={{ textAlign:'right', width:'70px'}} className={DataOmsetReportHarian[item0][item][item1]["bonus_harian"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetReportHarian[item0][item][item1]["bonus_harian"])}</td> 
                            <td style={{ textAlign:'right', width:'70px'}} className={DataOmsetReportHarian[item0][item][item1]["winlose_bersih"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetReportHarian[item0][item][item1]["winlose_bersih"])}</td> 
                            <td style={{ textAlign:'right', width:'70px'}} className={DataOmsetReportHarian[item0][item][item1]["naik_tampung"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetReportHarian[item0][item][item1]["naik_tampung"])}</td> 
                            <td style={{ textAlign:'right', width:'70px'}} className={DataOmsetReportHarian[item0][item][item1]["suntik_dana"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetReportHarian[item0][item][item1]["suntik_dana"])}</td> 
                        </tr>
                    ))}
                </tbody>
                </table>
              </td>
            </tr>
            ))
            ))
          ) : null
            }
            </tbody>
            </table>
          </div>
        </div>
        <div id="kasaranOmset" className="tab-content">
          <div style={{ textAlign: 'center', overflow:'auto', height:'80vh', width:'100%'}}>
            <table ref={tableKasaranOmset}  className='table table-bordered' style={{ width:'1600px', marginTop:"20px"}}>
              <thead>
                <tr>
                  <th rowSpan={2}>Asset</th>
                  <th rowSpan={2}>WINLOSE GROSS</th>
                  <th colSpan={2}>AKURAN</th>
                  <th colSpan={2}>BONUS</th>
                  <th rowSpan={2}>OTHER PUSAT</th>
                  <th rowSpan={2}>EXPEND</th>
                  <th rowSpan={2}>MAINTENANCE FEE</th>
                  <th rowSpan={2}>TOTAL</th>
                  <th rowSpan={2}>%</th>
                  <th rowSpan={2}>BONUS OPS</th>
                  <th rowSpan={2}>NET PROFIT</th>
                  <th rowSpan={2}>%</th>
                </tr>
                <tr>
                  <th>Nominal</th>
                  <th>%</th>
                  <th>Bonus</th>
                  <th>%</th>
                </tr>
              </thead>
              <tbody>
              { isLoading ? <tr><td>Loading...</td></tr> :
              ( DataOmsetKasaranOmset && typeof DataOmsetKasaranOmset === 'object') ? (
                Object.keys(DataOmsetKasaranOmset).map((item,index) => (
                <tr key={'rkasaran'+index}  style={DataOmsetKasaranOmset[item]["asset"] === "Total" ? { backgroundColor: "yellow" } : null} className={DataOmsetKasaranOmset[item]["nama_toko"] === "Total" ? 'total_row' : null}>
                        <td style={{ textAlign:'left', width:'70px'}}>{DataOmsetKasaranOmset[item]["asset"]}</td> 
                        <td style={{ textAlign:'right', width:'70px'}} className={DataOmsetKasaranOmset[item]["winlose_gross"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetKasaranOmset[item]["winlose_gross"])}</td> 
                        <td style={{ textAlign:'right', width:'70px'}} className={DataOmsetKasaranOmset[item]["akuran_nominal"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetKasaranOmset[item]["akuran_nominal"])}</td> 
                        <td style={{ textAlign:'center', width:'50px'}} className={DataOmsetKasaranOmset[item]["persen_akuran"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetKasaranOmset[item]["persen_akuran"])} %</td> 
                        <td style={{ textAlign:'right', width:'70px'}} className={DataOmsetKasaranOmset[item]["bonus_nominal"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetKasaranOmset[item]["bonus_nominal"])}</td> 
                        <td style={{ textAlign:'center', width:'50px'}} className={DataOmsetKasaranOmset[item]["persen_bonus"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetKasaranOmset[item]["persen_bonus"])} %</td> 
                        <td style={{ textAlign:'right', width:'70px'}} className={DataOmsetKasaranOmset[item]["other_pusat"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetKasaranOmset[item]["other_pusat"])}</td> 
                        <td style={{ textAlign:'right', width:'70px'}} className={DataOmsetKasaranOmset[item]["expend"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetKasaranOmset[item]["expend"])}</td> 
                        <td style={{ textAlign:'right', width:'70px'}} className={DataOmsetKasaranOmset[item]["maintenance_fee"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetKasaranOmset[item]["maintenance_fee"])}</td> 
                        <td style={{ textAlign:'right', width:'70px'}} className={DataOmsetKasaranOmset[item]["total"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetKasaranOmset[item]["total"])}</td> 
                        <td style={{ textAlign:'center', width:'50px'}} className={DataOmsetKasaranOmset[item]["persen_total"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetKasaranOmset[item]["persen_total"])} %</td> 
                        <td style={{ textAlign:'right', width:'70px'}} className={DataOmsetKasaranOmset[item]["bonus_ops"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetKasaranOmset[item]["bonus_ops"])}</td> 
                        <td style={{ textAlign:'right', width:'70px'}} className={DataOmsetKasaranOmset[item]["net_profit"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetKasaranOmset[item]["net_profit"])}</td> 
                        <td style={{ textAlign:'center', width:'50px'}} className={DataOmsetKasaranOmset[item]["persen_net_profit"] < 0 ? 'redFont': null}>{formatNumberWithoutDecimals(DataOmsetKasaranOmset[item]["persen_net_profit"])} %</td> 
                    </tr>
                ))
              ) : null
              }
            </tbody>
            </table>
          </div>
        </div>
        <div id="trendOmset" className="tab-content" style={{ overflow:'auto', height:'80vh', width:'100%'}}>

        { isLoading ? <tr><td>Loading...</td></tr> :
        ( SusunanAsset && typeof SusunanAsset === 'object') ? (
          Object.keys(SusunanAsset).map((key,index) => (
                    <div style={{ textAlign: 'center',  height:'50vh', width:'100%', display:'flex', flexDirection:'column', justifyContent:'space-around', alignItems:'center'}} key={'trend'+index}>
                      <h3>{SusunanAsset[key]}</h3>
                      <div style={{ display:'flex', width:'100%',height:'50vh', flexDirection:'row'}} key={'trend1'+index}>
                        <div key={`omset-trend-${SusunanAsset[key]}`} style={{ width: '45%', marginBottom: '20px' }}>
                        {DataOmsetMonthTrend &&
  typeof DataOmsetMonthTrend === 'object' &&
  DataOmsetMonthTrend[SusunanAsset[key]] &&
  typeof DataOmsetMonthTrend[SusunanAsset[key]] === 'object' && // ADDED CHECK
  DataOmsetMonthTrend[SusunanAsset[key]].datasets ? (
                          <Line
                            data={DataOmsetMonthTrend[SusunanAsset[key]]}
                            options={{
                              responsive: true,
                              plugins: {
                                legend: {
                                  position: 'top',
                                },
                                title: {
                                  display: true,
                                  text: '',
                                },
                                // Add this 'datalabels' configuration to display values on the bars
                                datalabels: {
                                  anchor: 'end',  // Position of the label relative to the bar
                                  align: 'end',    // Alignment of the label
                                  offset: -10,   // Offset the label from the end of the bar
                                  color: 'black',  // Color of the label text
                                  font: {
                                    size: 12,      // Font size of the label
                                  },
                                  formatter: (value, context) => {
                                    const label = context.dataset.label ? `${context.dataset.label}:` : ''; // Get the dataset label for each bar
                                    const roundedValue = Math.round(value); // Round the value to 0 decimal places
                                    const formattedValue = roundedValue.toLocaleString('id-ID'); // Format the value
                                    return `${formattedValue}`; // Combine label and formatted value
                                  },
                                },
                              },
                            }}
                          />
                          ) : (
                            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                              <p>Loading...</p>
                            </div>
                          )}
                        </div>
                        <div key={`omset-rupiah-${SusunanAsset[key]}`} style={{ width: '45%', marginBottom: '20px' }}> 
                        {DataOmsetMonthTrendRupiah &&
  typeof DataOmsetMonthTrendRupiah === 'object' &&
  DataOmsetMonthTrendRupiah[SusunanAsset[key]] &&
  typeof DataOmsetMonthTrendRupiah[SusunanAsset[key]] === 'object' && // ADDED CHECK
  DataOmsetMonthTrendRupiah[SusunanAsset[key]].datasets ? (
                          <Line
                            data={DataOmsetMonthTrendRupiah[SusunanAsset[key]]}
                            options={{
                              responsive: true,
                              plugins: {
                                legend: {
                                  position: 'top',
                                },
                                title: {
                                  display: true,
                                  text: 'Dalam Ribuan',
                                },
                                // Add this 'datalabels' configuration to display values on the bars
                                datalabels: {
                                  anchor: 'end',  // Position of the label relative to the bar
                                  align: 'end',    // Alignment of the label
                                  offset: -10,   // Offset the label from the end of the bar
                                  color: 'black',  // Color of the label text
                                  font: {
                                    size: 12,      // Font size of the label
                                  },
                                  formatter: (value, context) => {
                                    // const label = context.dataset.label ? `${context.dataset.label}:` : ''; // Get the dataset label for each bar
                                    value = value / 1000;
                                    const roundedValue = Math.round(value); // Round the value to 0 decimal places
                                    const formattedValue = roundedValue.toLocaleString('id-ID'); // Format the value
                                    return `${formattedValue}`; // Combine label and formatted value
                                  },
                                },
                              },
                            }}
                          />
                          ) : (
                            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                              <p>Loading...</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                ))
              ) : null
              }
          </div>
      </div>

    </div>
  );
};


export default ReportOmset;